import { CommerceService } from "@/services/commerce"
import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

export const admStatsByCustomer = async ({ admNumber, year, page, size, sort, lastYearData }) => {
  const yearToUse = year && year > 0 ? year : new Date().getFullYear()
  const sortToUse = sort && sort.length > 0 ? sort : "revenue.desc"

  const variables = { admNumber, year: yearToUse, page, size, sort: sortToUse }
  const fields = ["number", "numberOfElements", "totalElements", "totalPages"]

  const graphiQLQueryObject = [
    {
      method: "admStatsByCustomer",
      variables: variables,
      fields,
      expandedFields: {
        content: ["year", "customerNumber", "revenue", "quantity", "margin", "amount"],
      },
    },
  ]
  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
  let queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

  if (!queryResponse) throw new Error("Data retrieval for adm stats by customer failed")

  queryResponse = await addCustomerName(queryResponse, size)

  if (!lastYearData) {
    return { admStats: queryResponse?.admStatsByCustomer || null }
  }

  return await addLastYearRevenue(queryResponse, yearToUse)
}

async function addLastYearRevenue(queryResponse, year) {
  if (!queryResponse?.admStatsByCustomer?.content || queryResponse?.admStatsByCustomer?.content?.length === 0) {
    return { admStats: queryResponse?.admStatsByCustomer || null }
  }
  const secondGraphiQLQueryObject = []

  const lastYearFields = ["year", "revenue", "margin"]
  for (const stat of queryResponse.admStatsByCustomer.content || {}) {
    const lastYearVariables = { customerNumber: stat.customerNumber, year: year - 1 }
    const queryObject = {
      method: `lastYearRevenue_${stat.customerNumber}: customerStatsByArticleMainGroup`,
      variables: lastYearVariables,
      fields: lastYearFields,
    }

    secondGraphiQLQueryObject.push(queryObject)
  }
  const mappedQueryRevenue = EinzaGraphiQLService.formQuery(secondGraphiQLQueryObject)
  const queryResponseRevenue = (await EinzaGraphiQLService.getData(mappedQueryRevenue))?.data

  if (!queryResponseRevenue) throw new Error("Data retrieval for last year revenue failed")

  for (let stat of queryResponse.admStatsByCustomer.content || {}) {
    stat["lastYearRevenue"] = {
      year: queryResponseRevenue[`lastYearRevenue_${stat.customerNumber}`][0]?.year,
      revenue: queryResponseRevenue[`lastYearRevenue_${stat.customerNumber}`]?.reduce(
        (accumulator, { revenue }) => accumulator + revenue,
        0,
      ),
      margin: queryResponseRevenue[`lastYearRevenue_${stat.customerNumber}`]?.reduce(
        (accumulator, { margin }) => accumulator + margin,
        0,
      ),
    }
  }
  return { admStats: queryResponse.admStatsByCustomer }
}

async function addCustomerName(queryResponse, limit) {
  if (
    !queryResponse?.admStatsByCustomer ||
    !queryResponse?.admStatsByCustomer?.content ||
    queryResponse?.admStatsByCustomer?.content.length === 0
  )
    return queryResponse
  const commerceApi = CommerceService.api()

  // add quotation marks for commerce tools
  const customerNumbers = queryResponse?.admStatsByCustomer?.content.map((el) => `"${el.customerNumber}" `)
  const customerNames =
    (
      await commerceApi
        .customers()
        .get({
          queryArgs: {
            where: `(customerNumber in (${customerNumbers}))`,
            limit: limit,
            expand: [],
          },
        })
        .execute()
    )?.body?.results?.reduce((map, customer) => {
      map[customer.customerNumber] = {
        companyName: customer?.companyName,
        id: customer?.id,
        customerBranch: customer?.custom?.fields?.deliveryBranch || customer?.custom?.fields?.customerBranch,
      }
      return map
    }, {}) || null

  if (!customerNames) return

  for (let stat of queryResponse?.admStatsByCustomer?.content || {}) {
    stat["customerName"] = customerNames[stat.customerNumber]?.companyName
    stat["customerId"] = customerNames[stat.customerNumber]?.id
    stat["customerBranch"] = customerNames[stat.customerNumber]?.customerBranch
  }

  return queryResponse
}
